module.exports = __webpack_public_path__ + "img/con_3.8db890b0.svg";